import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "n-conversation-thread__container" }
const _hoisted_2 = { class: "n-conversation-thread__message-list" }
const _hoisted_3 = {
  key: 0,
  class: "n-conversation-thread__message-divider"
}
const _hoisted_4 = {
  key: 1,
  class: "n-conversation-thread__message-divider--whisper"
}
const _hoisted_5 = ["innerHTML"]

import { ref, onMounted, watch, nextTick } from 'vue';
import moment from 'moment';
import NIcon from '../../brand/icon/icon.vue';
import NTextMessage from './text-message.vue';
import NImageMessage from './image-message.vue';
import NVideoMessage from './video-message.vue';
import NAudioMessage from './audio-message.vue';
import NFileMessage from './file-message.vue';
import { Message, TextMessage } from './message';
import NAppMessage from './app-message.vue';
import QuickReplies from './quick-replies.vue';
import { MessageContent } from './messageContent';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-conversation-thread',
},
  __name: 'conversation-thread',
  props: {
  outboundMessageColour: {
    type: String,
    default: '#062b80',
  },
  messages: {
    type: Array as PropType<Message[]>,
    required: true,
  },
  displayAvatar: {
    type: Boolean,
    default: false,
  },
  enableAvatarTooltip: {
    type: Boolean,
    default: false,
  },
  readonlyApps: {
    type: Boolean,
    default: true,
  },
},
  emits: ["sendQuickReply"],
  setup(__props, { emit: __emit }) {



const props = __props;

const emit = __emit;

const scrollContainer = ref<HTMLDivElement | null>(null);
const isScrolledToBottom = ref(true); // Default to true to scroll to bottom initially

function shouldShowTimestampDivider(current: Message, previous: Message) {
  if (!current || !previous) {
    return false;
  }
  const currentDate = moment(current.timestampUtc);
  const previousDate = moment(previous.timestampUtc);
  return currentDate.diff(previousDate, 'hours', false) !== 0;
}

function formatTimestampDivider(timestamp: Date): string {
  return moment(timestamp).format('MMM D, YYYY, h:mm A');
}

function shouldShowQuickReplies() {
  const lastMessage = props.messages[props.messages.length - 1] as TextMessage;
  return lastMessage && lastMessage.actions && lastMessage.actions.length;
}

function sendQuickReply(quickReply: any) {
  emit('sendQuickReply', quickReply);
}

function getMessagePosition(m: TextMessage): 'right' | 'left' {
  return m.direction === 'outbound' ? 'right' : 'left';
}

function getFormattedMessage(message: string): string {
  return new MessageContent(message).EscapeHtml().ProcessUrls().NewLinesToBreaks().Value;
}

function scrollToBottom(): void {
  if (!scrollContainer.value) return;
  scrollContainer.value.scrollTop = scrollContainer.value.scrollHeight;
  isScrolledToBottom.value = true;
}

// Watch for new messages and scroll to bottom if at the bottom
watch(
  () => props.messages.length,
  async () => {
    await nextTick(); // Wait for DOM update
    if (isScrolledToBottom.value) {
      scrollToBottom();
    }
  },
);

// Update isScrolledToBottom based on scroll position
function handleScroll() {
  if (!scrollContainer.value) return;
  const { scrollTop, scrollHeight, clientHeight } = scrollContainer.value;
  isScrolledToBottom.value = Math.abs(scrollHeight - scrollTop - clientHeight) < 10; // Allow small margin
}

onMounted(() => {
  scrollToBottom();
  if (scrollContainer.value) {
    scrollContainer.value.addEventListener('scroll', handleScroll);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "n-conversation-thread",
    ref_key: "scrollContainer",
    ref: scrollContainer
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_TransitionGroup, {
          name: "transitions",
          tag: "span"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messages, (m, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["n-conversation-thread__message-row transition-item", [`n-conversation-thread__message-row--${getMessagePosition(m)}`]])
              }, [
                (shouldShowTimestampDivider(m, __props.messages[index - 1]))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(formatTimestampDivider(m.timestampUtc)), 1))
                  : _createCommentVNode("", true),
                (m.type === 'whisper')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("span", {
                        innerHTML: getFormattedMessage(m.text)
                      }, null, 8, _hoisted_5)
                    ]))
                  : _createCommentVNode("", true),
                (m.type === 'text')
                  ? (_openBlock(), _createBlock(NTextMessage, {
                      key: 2,
                      message: m,
                      outboundMessageColour: __props.outboundMessageColour,
                      tooltipPosition: getMessagePosition(m) === 'right' ? 'left' : 'right',
                      displayAvatar: __props.displayAvatar,
                      enableAvatarTooltip: __props.enableAvatarTooltip
                    }, null, 8, ["message", "outboundMessageColour", "tooltipPosition", "displayAvatar", "enableAvatarTooltip"]))
                  : _createCommentVNode("", true),
                (m.type === 'app')
                  ? (_openBlock(), _createBlock(NAppMessage, {
                      key: 3,
                      message: m,
                      readonly: __props.readonlyApps,
                      brandColour: __props.outboundMessageColour,
                      displayAvatar: __props.displayAvatar,
                      enableAvatarTooltip: __props.enableAvatarTooltip,
                      position: getMessagePosition(m)
                    }, null, 8, ["message", "readonly", "brandColour", "displayAvatar", "enableAvatarTooltip", "position"]))
                  : _createCommentVNode("", true),
                (m.type === 'image')
                  ? (_openBlock(), _createBlock(NImageMessage, {
                      key: 4,
                      message: m,
                      displayAvatar: __props.displayAvatar,
                      enableAvatarTooltip: __props.enableAvatarTooltip,
                      tooltipPosition: getMessagePosition(m) === 'right' ? 'left' : 'right'
                    }, null, 8, ["message", "displayAvatar", "enableAvatarTooltip", "tooltipPosition"]))
                  : _createCommentVNode("", true),
                (m.type === 'video')
                  ? (_openBlock(), _createBlock(NVideoMessage, {
                      key: 5,
                      message: m,
                      displayAvatar: __props.displayAvatar,
                      enableAvatarTooltip: __props.enableAvatarTooltip,
                      tooltipPosition: getMessagePosition(m) === 'right' ? 'left' : 'right'
                    }, null, 8, ["message", "displayAvatar", "enableAvatarTooltip", "tooltipPosition"]))
                  : _createCommentVNode("", true),
                (m.type === 'audio')
                  ? (_openBlock(), _createBlock(NAudioMessage, {
                      key: 6,
                      message: m,
                      displayAvatar: __props.displayAvatar,
                      enableAvatarTooltip: __props.enableAvatarTooltip,
                      tooltipPosition: getMessagePosition(m) === 'right' ? 'left' : 'right'
                    }, null, 8, ["message", "displayAvatar", "enableAvatarTooltip", "tooltipPosition"]))
                  : _createCommentVNode("", true),
                (m.type === 'file')
                  ? (_openBlock(), _createBlock(NFileMessage, {
                      key: 7,
                      message: m,
                      outboundMessageColour: __props.outboundMessageColour,
                      displayAvatar: __props.displayAvatar,
                      enableAvatarTooltip: __props.enableAvatarTooltip,
                      tooltipPosition: getMessagePosition(m) === 'right' ? 'left' : 'right'
                    }, null, 8, ["message", "outboundMessageColour", "displayAvatar", "enableAvatarTooltip", "tooltipPosition"]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128)),
            (shouldShowQuickReplies())
              ? (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["n-conversation-thread__quick-replies transition-item", [
              `n-conversation-thread__quick-replies--${
                getMessagePosition(__props.messages[__props.messages.length - 1]) === 'right' ? 'left' : 'right'
              }`,
            ]]),
                  key: 'quick-replies'
                }, [
                  _createVNode(QuickReplies, {
                    actions: __props.messages[__props.messages.length - 1].actions,
                    messageColour: __props.outboundMessageColour,
                    onSendQuickReply: sendQuickReply
                  }, null, 8, ["actions", "messageColour"])
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}
}

})